import { IStore } from "../../model/runtime/state/Store";
import { UserPreferences } from "../../common/Constants";
import { ILanguage } from "../../model/language/Language";
import { ICredentialsService } from "../../../authentication/service/CredentialsService";
import { ILanguageService } from "../../service/language/LanguageService";
import Application from "../../../Application";

export default class GetAllLanguagesInteractor {
  private application: Application;
  private languageService: ILanguageService;
  private store: IStore;
  private credentialsService: ICredentialsService;

  constructor({
    application,
    store,
    languageService,
    credentialsService
  }: any) {
    this.application = application;
    this.store = store;
    this.languageService = languageService;
    this.credentialsService = credentialsService;
  }

  async getCurrentLanguageCode() {
    const currentLanguage = await this.credentialsService.getLanguage();
    return String(currentLanguage);
  }

  async execute() {
    const languages = await this.languageService.getLanguages();
    let currentLanguageCode = await this.getCurrentLanguageCode();
    currentLanguageCode = currentLanguageCode
      ? currentLanguageCode
      : UserPreferences.DEFAULT_LANGUAGE;

    const selectedLanguage = languages.find(
      (langugage: ILanguage) => langugage.code === currentLanguageCode
    );
    this.store.update({ languages, selectedLanguage });
  }
}
